import { Box } from "@chakra-ui/react";
import { IconType } from "common";
import { GiDragonHead } from "react-icons/gi";
import { Gi3dHammer } from "react-icons/gi";
import { GiAlienStare } from "react-icons/gi";
import { GiAmericanFootballBall } from "react-icons/gi";
import { GiAndroidMask } from "react-icons/gi";
import { GiAngularSpider } from "react-icons/gi";
import { GiAquarium } from "react-icons/gi";
import { GiBandana } from "react-icons/gi";
import { toHexColor } from "./toHexColor";
import { GiBeaver } from "react-icons/gi";
import { GiGecko } from "react-icons/gi";
import { GiOwl } from "react-icons/gi";
import { GiDuck } from "react-icons/gi";
import BadgerLogo from "../assets/badger_logo.svg";
import PlatypiLogo from "../assets/platypi_logo.svg";
import OwlLogo from "../assets/owl_logo.svg";
import GeckoLogo from "../assets/gecko_logo.svg";
import { hexToCSSFilter } from "hex-to-css-filter";

interface AppIconProps {
  type: IconType;
  color?: string;
  size?: number;
  backgroundColor?: string;
  paddingTop?: number;
  paddingBottom?: number;
  borderRadius?: number | string;
  selected?: boolean;
  onClick?: () => void;
}

export const AppIcon = ({
  paddingTop,
  paddingBottom,
  backgroundColor,
  type,
  color,
  size,
  borderRadius,
  selected,
  onClick,
}: AppIconProps) => {
  const getIcon = ({ iconColor }: { iconColor?: string }) => {
    switch (type) {
      case IconType.Dragon: {
        return <GiDragonHead size={size} />;
      }
      case IconType.Hammer: {
        return <Gi3dHammer size={size} />;
      }
      case IconType.Alien: {
        return <GiAlienStare size={size} />;
      }
      case IconType.Football: {
        return <GiAmericanFootballBall size={size} />;
      }
      case IconType.Android: {
        return <GiAndroidMask size={size} />;
      }
      case IconType.Spider: {
        return <GiAngularSpider size={size} />;
      }
      case IconType.Aquarium: {
        return <GiAquarium size={size} />;
      }
      case IconType.Bandana: {
        return <GiBandana size={size} />;
      }
      case IconType.Beaver: {
        return <GiBeaver size={size} />;
      }
      case IconType.Gecko: {
        return <GiGecko size={size} />;
      }
      case IconType.Owl: {
        return <GiOwl size={size} />;
      }
      case IconType.Duck: {
        return <GiDuck size={size} />;
      }
      case IconType.BadgerLogo: {
        return (
          <img
            src={BadgerLogo}
            alt={"logo"}
            style={{
              width: `${(size ?? 50) + 20}px`,
              height: `${(size ?? 50) + 20}px`,
              filter: hexToCSSFilter(
                toHexColor(iconColor ?? "#000000")
              ).filter.replace(";", ""),
            }}
          />
        );
      }
      case IconType.PlatypiLogo: {
        return (
          <img
            src={PlatypiLogo}
            alt={"logo"}
            style={{
              width: `${(size ?? 50) + 20}px`,
              height: `${(size ?? 50) + 20}px`,
              filter: hexToCSSFilter(
                toHexColor(iconColor ?? "#000000")
              ).filter.replace(";", ""),
            }}
          />
        );
      }
      case IconType.OwlLogo: {
        return (
          <img
            src={OwlLogo}
            alt={"logo"}
            style={{
              width: `${(size ?? 50) + 20}px`,
              height: `${(size ?? 50) + 20}px`,
              filter: hexToCSSFilter(
                toHexColor(iconColor ?? "#000000")
              ).filter.replace(";", ""),
            }}
          />
        );
      }
      case IconType.GeckoLogo: {
        return (
          <img
            src={GeckoLogo}
            alt={"logo"}
            style={{
              width: `${(size ?? 50) + 20}px`,
              height: `${(size ?? 50) + 20}px`,
              filter: hexToCSSFilter(
                toHexColor(iconColor ?? "#000000")
              ).filter.replace(";", ""),
            }}
          />
        );
      }
    }
  };

  return (
    <Box
      color={color ? toHexColor(color) : undefined}
      display={"flex"}
      alignItems={"center"}
      justifyContent={"center"}
      paddingTop={paddingTop}
      paddingBottom={paddingBottom}
      backgroundColor={backgroundColor}
      borderRadius={borderRadius}
      cursor={onClick ? "pointer" : undefined}
      onClick={onClick}
      boxShadow={selected ? "outline" : undefined}
    >
      {getIcon({ iconColor: color })}
    </Box>
  );
};
